export interface ReconciliationDto {
    Reg: string;
    checkin_date: string;
    location: string;
    created_date: string;
    vehicle_presence_check_reconciliation_outcome?: string;
    vehicle_presence_check_reconciliation_date?: string;
    vehicle_presence_check_reconciliation_by?: string;

    vehicle_key_check_reconciliation_outcome?: string;
    vehicle_key_check_reconciliation_date?: string;
    vehicle_key_check_reconciliation_by?: string;

    vehicle_is_locked_check_reconciliation_outcome?: string;
    vehicle_is_locked_check_reconciliation_date?: string;
    vehicle_is_locked_check_reconciliation_by?: string;

    check_type: string;
}

export const vehiclePresenceOutcomes = [
        { name: 'Vehicle present at branch', value: 'Present' },
        { name: 'On Rent', value: 'OnRent' },
        { name: 'At Workshop', value: 'AtWorkshop' },
        { name: 'On a Non-Revenue Movement', value: 'NonRevenueMovement' },
        { name: 'De-fleeted', value: 'Defleeted' },
        { name: 'Director personal vehicle', value: 'DirectorPersonalVehicle' },
        { name: 'Missing', value: 'Missing' },
    ];

export const branchOutcomes = [
        { name: 'On Rent at Stockport Branch', value: 'OnRentBranch:Stockport' },
        { name: 'On Rent at Chester Branch', value: 'OnRentBranch:Chester' },
        { name: 'On Rent at Preston Branch', value: 'OnRentBranch:Preston' },
        { name: 'On Rent at Oldham Branch', value: 'OnRentBranch:Oldham' },
        { name: 'At Stockport Branch', value: 'Branch:Stockport' },
        { name: 'At Chester Branch', value: 'Branch:Chester' },
        { name: 'At Preston Branch', value: 'Branch:Preston' },
        { name: 'At Oldham Branch', value: 'Branch:Oldham' },
    ];